export default __webpack_public_path__ + "static/media/FFL.663a80fa.png";